import {WordMasksController} from "../components/partials/WordMasks";
import {WordMaskObject} from "../types.d";

export const checkQuota = (
    { content, wordMasksController, includedWords }: {
        content: string;
        wordMasksController: WordMasksController,
        includedWords: string[]
    }
): { tokens: string[], result: string } => {
    let resultContent = content.toLowerCase();

    const wordsList = [
        ...wordMasksController.allWords
            .map((value) => {
                return value.word.toLowerCase().trim();
            })
            .sort((a, b) => {
                return b.length - a.length;
            }),
        ...includedWords.map(word => word.toLowerCase())
    ];

    const filteredWordsList = wordsList
        .filter((value) => {
            if (!value.match('[\\s,-_\/]')) {
                return false;
            }

            const isExists = resultContent.indexOf(value) > -1;

            if (isExists) {
                resultContent = resultContent.replace(value, '');
            }

            return isExists;
        });

    const rawTokens = resultContent.split(' ');
    const tokens = filteredWordsList;
    let token;

    for (const rawToken of rawTokens) {
        if (rawToken.indexOf("'") !== -1) {
            continue;
        }

        token = rawToken
            .replace(/[^A-Za-z0-9\u00C0-\u00ff]/ig, '');

        if (token !== '' && tokens.indexOf(token) === -1) {
            tokens.push(token.toLowerCase());
        }
    }

    const result = JSON.stringify(tokens);

    return { result, tokens };
};

export const checkCounter = (words: WordMaskObject[], tokens: string[]) => {
    return tokens.filter(token => words.filter(word => word.rank <= 10 && word.word === token).length).length < 1;
};
